import { Select as SelectComponent } from '@randstad-lean-mobile-factory/react-components-core';
import { PropsWithChildren } from 'react';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../ErrorMessage';

import { SelectProps } from './Select.types';

/**
 * @example <Select control={control} name="status" size="medium">
 *            <Option value="cadre">cadre</Option>
 *            <Option value="agent">agent de maîtrise</Option>
 *            <Option value="ouvrier">ouvrier</Option>
 *          </Select>
 */
export const Select = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TClearable extends boolean = false,
>({
  name,
  control,
  defaultValue,
  disabled,
  formFieldClassName,
  ...selectProps
}: PropsWithChildren<SelectProps<TFieldValues, TName, TClearable>>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  return (
    <div className={formFieldClassName}>
      <SelectComponent
        {...selectProps}
        {...field}
        onChange={value => {
          field.onChange(value ?? null);
          field.onBlur();
        }}
        error={!!error}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
